import React from "react";
import { parseISO } from "date-fns";
import { fullDateFullYearFormat } from "@common/helpers/date";
import { formatBusinessDate } from "@helpers/date";
import { Button } from "@design-system/Button/Button";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { ArrowCornerIcon } from "@icons";
import styles from "./FinancialDocumentMatches.module.scss";

interface ViewAction {
    onClick: () => void;
    tooltip: string;
    testId: string;
}

interface Props {
    dateIso: string;
    description: React.ReactNode;
    testId: string;
    dateTestId: string;
    descriptionTestId: string;
    view?: ViewAction;
}

export const FinancialDocumentLinkRow: React.FC<Props> = ({
    dateIso,
    description,
    testId,
    dateTestId,
    descriptionTestId,
    view,
}) => (
    <article className={styles.item} data-testid={testId}>
        <main>
            <div className="text-gray-700" data-testid={dateTestId}>
                {formatBusinessDate(parseISO(dateIso), fullDateFullYearFormat)}
            </div>

            <div className={styles.description} data-testid={descriptionTestId}>
                {description}
            </div>
        </main>

        {view && (
            <aside>
                <Tooltip content={view.tooltip}>
                    <Button
                        variant="secondary"
                        size="sm"
                        iconOnly
                        onClick={view.onClick}
                        aria-label={view.tooltip}
                        data-testid={view.testId}
                    >
                        <ArrowCornerIcon />
                    </Button>
                </Tooltip>
            </aside>
        )}
    </article>
);
